export const navItems = [
  { name: "Dashboard", link: "admin" },
  { name: "Profile", link: "profile" },
];
